module.exports = __webpack_public_path__ + "img/application_question_icon.cade19a4.svg";